module.exports = __webpack_public_path__ + "static/bottom_left-9b2d4f716ea39626ce500b916dd96301.png";